"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsFactory = void 0;
var settingsValidation_1 = require("@splitsoftware/splitio-commons/cjs/utils/settingsValidation");
var runtime_1 = require("@splitsoftware/splitio-commons/cjs/utils/settingsValidation/runtime");
var builtinLogger_1 = require("@splitsoftware/splitio-commons/cjs/utils/settingsValidation/logger/builtinLogger");
var LocalhostFromObject_1 = require("@splitsoftware/splitio-commons/cjs/sync/offline/LocalhostFromObject");
var consent_1 = require("@splitsoftware/splitio-commons/cjs/utils/settingsValidation/consent");
var browser_1 = require("./defaults/browser");
var browser_2 = require("./storage/browser");
var browser_3 = require("./integrations/browser");
var params = {
    defaults: browser_1.defaults,
    acceptKey: true, acceptTT: true,
    runtime: runtime_1.validateRuntime,
    storage: browser_2.validateStorage,
    integrations: browser_3.validateIntegrations,
    logger: builtinLogger_1.validateLogger,
    localhost: function () { return (0, LocalhostFromObject_1.LocalhostFromObject)(); },
    consent: consent_1.validateConsent,
};
function settingsFactory(config) {
    return (0, settingsValidation_1.settingsValidation)(config, params);
}
exports.settingsFactory = settingsFactory;
